<template>
  <div class="wrap">
    <div class="query-banner">
      <p>成绩与证书查询</p>
    </div>
    <result />
  </div>
</template>
<script>
import result from './result.vue'
import { mapMutations } from 'vuex';
export default {
  name: '',
  props: {},
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  methods: {
    ...mapMutations({
      SET_SHOWINFO:"user/SET_SHOWINFO"
    })
  },
  created() {
let userinfo = localStorage.getItem("userinfo") ? JSON.parse(localStorage.getItem("userinfo")):null
if(userinfo && (!userinfo.cardNumber || !userinfo.userName)){
  this.SET_SHOWINFO(true)
}
  },
 methods: {
   
 },
  components: {
    // reason,
    result
  },
  filters: {}
};
</script>
<style lang='scss' scoped>
.wrap{
  // background-color: #fff;
}
.wrap .query-banner{
  position: relative;
  height: 400px;
  background-image: url("../../../assets/cjyzscx.png");
  text-align: center;
  line-height: 400px;
  p{
    font-size: 48px;
    font-weight: 400;
    color: #fff;
  }
}


</style>